import {createContext} from "react"


export const UpdateContext = createContext<{lastUpdate: Date | null, setLastUpdate: (date: Date| null) => any}>({lastUpdate: null, setLastUpdate: (date) => {}})
